module.exports = __webpack_public_path__ + "img/3.7a570e94.png";